"use client"
import React, { useMemo } from 'react'
import Navbar from '../../components/agent/common/Navbar'
import AgentMainLeads from '../../components/agent/lead/MainLead'
import AdminMainLeads from '../../components/admin/Lead/MainLead'

const AgentLeads = () => {
  const shouldUseAdminLeads = useMemo(() => {
    try {
      const userData = localStorage.getItem('user');
      const role = (userData ? JSON.parse(userData)?.role : '') || '';
      const normalizedRole = role.toLowerCase().trim();
      return ['sub-admin', 'subadmin', 'admin', 'super-admin', 'superadmin'].includes(normalizedRole);
    } catch {
      return false;
    }
  }, []);

  return (
    <div className="min-h-screen">
    <Navbar />
    <main className="p-4 md:p-8">
     {shouldUseAdminLeads ? <AdminMainLeads basePath="/agent" /> : <AgentMainLeads />}
    </main>
  </div>
  )
}

export default AgentLeads